import React, { PropTypes, Component } from 'react'
import styles from './styles'
import DataTable from './index'
import TextCell from './dataCell/textCell'
import InputCell from './dataCell/inputCell'
import DateInputCell from './dataCell/dateInputCell'
import PasswordCell from './dataCell/passwordCell'
import AutoCompleteCell from './dataCell/autoCompleteCell'
import misc from 'utils/misc'

export default class DataRow extends Component {
  static propTypes = {
    schemas: PropTypes.array.isRequired,
    data: PropTypes.object,
    onDataUpdate: PropTypes.func,
  };

  constructor (props) {
    super(props)
    // inputCell => onChange
    this.onChange = (key, value) => {
      const updatedData = misc.deepCopy(this.props.data)
      updatedData[key] = value
      if (this.props.onDataUpdate) {
        this.props.onDataUpdate(updatedData)
      }
    }

    this.onDateChange = (key, value) => {
      if (this.props.onDataUpdate && misc.isValidDateString(value)) {
        const updatedData = misc.deepCopy(this.props.data)
        updatedData[key] = value
        this.props.onDataUpdate(updatedData)
      }
    }

    // dropDownCell => onSelect
    this.onSelect = (key, itemId) => {
      const updatedData = misc.deepCopy(this.props.data)
      updatedData[key] = itemId ? itemId.toString() : ''
      if (this.props.onDataUpdate) {
        this.props.onDataUpdate(updatedData)
      }
    }
  }

  shouldComponentUpdate (nextProps) {
    return !misc.isObjectEqual(this.props, nextProps)
  }

  render () {
    const { schemas, data } = this.props
    const CellType = DataTable.CellType

    return (
      <div className={styles.dataRow} >
        {schemas.map(schema => {
          const cellProps = {}
          cellProps.key = `${data._id} ${schema.key}`
          cellProps.dataKey = schema.key
          cellProps.width = schema.width
          switch (schema.type) {
            case CellType.text:
              cellProps.text = data[schema.key]
              return <TextCell {...cellProps} />

            case CellType.input:
              cellProps.value = data[schema.key]
              cellProps.onChange = this.onChange
              return <InputCell {...cellProps} />

            case CellType.date:
              cellProps.value = data[schema.key]
              cellProps.onChange = this.onDateChange
              return <DateInputCell {...cellProps} />

            case CellType.password:
              cellProps.onChange = this.onChange
              return <PasswordCell {...cellProps} />

            case CellType.autoComplete:
            case CellType.dropDown:
              cellProps.value = schema.map[data[schema.key].toString()]
              cellProps.map = schema.map
              cellProps.onSelect = this.onSelect
              if (schema.type === CellType.dropDown) {
                cellProps.dropDown = true
              }
              return <AutoCompleteCell {...cellProps} />


            default:
          }
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataRow.jsx